import { createFileRoute } from "@tanstack/react-router";
import heroImg from "@/assets/junk.jpg";
import { ServicePage } from "@/components/ServicePage";
import { services } from "@/lib/service-content";
import { faqJsonLd, serviceJsonLd, breadcrumbJsonLd } from "@/lib/site";

export const Route = createFileRoute("/estate-cleanouts")({
  head: () => ({
    meta: [
      { title: services["estate-cleanouts"].metaTitle },
      { name: "description", content: services["estate-cleanouts"].metaDescription },
      { property: "og:title", content: services["estate-cleanouts"].metaTitle },
      { property: "og:description", content: services["estate-cleanouts"].metaDescription },
      { property: "og:url", content: "https://anchorsrq.com/estate-cleanouts" },
    ],
    links: [{ rel: "canonical", href: "https://anchorsrq.com/estate-cleanouts" }, { rel: "preload", as: "image", href: heroImg, fetchpriority: "high" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(breadcrumbJsonLd([{ name: 'Home', url: 'https://anchorsrq.com/' }, { name: 'Services', url: 'https://anchorsrq.com/#services' }, { name: 'Estate Cleanouts', url: 'https://anchorsrq.com/estate-cleanouts' }])) },
      { type: "application/ld+json", children: JSON.stringify(serviceJsonLd({ slug: "estate-cleanouts", name: 'Estate Cleanouts', serviceType: 'Estate Cleanout', description: 'Compassionate, end-to-end estate cleanouts for Sarasota-area families, executors, and probate attorneys — sorting, donation coordination, and complete removal handled by the Anchor Services team.' })) },
      { type: "application/ld+json", children: JSON.stringify(faqJsonLd(services["estate-cleanouts"].faqs)) },
    ],
  }),
  component: () => <ServicePage {...services["estate-cleanouts"]} heroImg={heroImg} />,
});
